import { createAction, props } from '@ngrx/store';
import {
  StudyFile,
  StudyShareFileGet,
} from 'src/app/models/Study/study-file.model';
import {
  SaleHorseStudyBase,
  Study,
  StudyDraftSubmissionAcknowledgementsRequestDto,
  StudyListItem,
} from 'src/app/models/Study/study.model';
import { HttpError } from 'src/app/models/common/http-error.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';
import { SaleHorseSetting } from 'src/app/models/sales/sale-horse-settings.model';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import {
  Status,
  StudyStatus,
  UpdateStatusFileResponse,
  UpdateStudyAndStudyFileStatusResponse,
} from 'src/app/models/status/status.model';
import { StudySaleSubmission } from '../../../models/Study/study-sale-submission';
import {
  ActivityLogModel,
  ActivityLogResponseModel,
} from '../../../models/activity-log/activity-log.model';
import { LookupModel } from '../../../models/common/lookup.model';
import { ViewMode } from '../../enums/view-mode.emun';
import { ManifestDto } from '../../models/manifest-dto';

export const ResetData = createAction('[Studies] Reset Data');

export const GetStudies = createAction('[Studies] Get Studies', props<{ loadManifest: boolean }>());

export const GetStudiesSuccess = createAction(
  '[Studies] Get Studies Success',
  props<{ studies: StudyListItem[] }>()
);

export const GetStudiesManifestSuccess = createAction(
  '[Studies] Get Studies Manifest Success',
  props<{ manifest: ManifestDto }>()
);

export const GetStudiesFailure = createAction(
  '[Studies] Get Studies Failure',
  props<{ err: HttpError }>()
);

export const GetStudiesManifestFailure = createAction(
  '[Studies] Get Studies Manifest Failure',
  props<{ err: HttpError }>()
);

export const GetStudyById = createAction(
  '[Studies] Get Study By Id',
  props<{ studyId: number; loadStudyFilesBySaleHorse: boolean }>()
);

export const GetStudyByIdSuccess = createAction(
  '[Studies] Get Study By Id Success',
  props<{
    studyProfile: Study;
    studyFiles: StudyFile[];
    studyStatus: StudyStatus;
  }>()
);

export const GetStudyFiles = createAction(
  '[Studies] Get Study Files',
  props<{ saleId: number; horseId: number }>()
);
export const GetStudyFilesByStudyId = createAction(
  '[Studies] Get Study Files',
  props<{ studyId: number }>()
);
export const GetStudyFilesSuccess = createAction(
  '[Studies] Get Study Files Success',
  props<{ studyFiles: StudyFile[]; saleId: number; horseId: number, isSalesCompany: boolean }>()
);
export const GetStudyFilesFailure = createAction(
  '[Studies] Get Study Files Failure',
  props<{ err: any }>()
);
export const GetStudyByIdFailure = createAction(
  '[Studies] Get Study By Id Failure',
  props<{ err: any }>()
);

export const GetStudyPdfFilesByStudyId = createAction(
  '[Studies] Get Study Pdf Files',
  props<{ saleId: number; horseId: number }>()
);

export const GetStudyPdfFilesByStudyIdSuccess = createAction(
  '[Studies] Get Study Pdf Files Success',
  props<{ studyFiles: StudyFile[] }>()
);
export const GetStudyPdfFilesByStudyIdFailure = createAction(
  '[Studies] Get Study Pdf Files Failure',
  props<{ err: any }>()
);

export const GetStatuses = createAction('[Studies] Get Statuses');

export const GetStatusesSuccess = createAction(
  '[Studies] Get Statuses Success',
  props<{ statuses: Status[] }>()
);

export const GetStatusesFailure = createAction(
  '[Studies] Get Statuses Failure',
  props<{ err: any }>()
);

export const GetStudyStatus = createAction(
  '[Studies] Get Study Status',
  props<{ studyId: number }>()
);

export const GetStudyStatusSuccess = createAction(
  '[Studies] Get Study Status Success',
  props<{ status: StudyStatus }>()
);

export const GetStudyStatusFailure = createAction(
  '[Studies] Get Study Status Failure',
  props<{ err: any }>()
);

export const GetMediaGroups = createAction('[Studies] Get Media Groups');

export const GetMediaGroupsSuccess = createAction(
  '[Studies] Get Media Groups Success',
  props<{ mediaGroups: MediaGroup[] }>()
);

export const GetMediaGroupsFailure = createAction(
  '[Studies] Get Media Groups Failure',
  props<{ err: any }>()
);

export const CreateStudyFile = createAction(
  '[Studies] Create Study File',
  props<{
    saleId: number;
    horseId: number;
    file: File;
    studyId?: number;
    isAdditional?: boolean;
    mediaCategoryId?: number;
  }>()
);

export const CancelStudySubmission = createAction(
  '[Studies] Cancel Study Submission for Sale/Horse',
  props<{
    saleId: number;
    horseId: number;
  }>()
);

export const SetStudyActiveStatusFiles = createAction(
  '[Studies] Archive Study Files',
  props<{
    studyId: number;
    isActive: boolean;
  }>()
);

export const ClearSetStudyActiveStatusFiles = createAction(
  '[Studies] Clear Archive Study Files'
);

export const CreateStudyFileSuccess = createAction(
  '[Studies] Create Study File Success',
  props<{ studyFile: StudyFile }>()
);

export const CreateStudyFileFailure = createAction(
  '[Studies] Create Study File Failure',
  props<{ err: any }>()
);

export const CancelStudyFiles = createAction(
  '[Studies] Delete Study Files for Sale/Horse',
  props<{
    saleId: number;
    horseId: number;
    studyId: number;
  }>()
);

export const CancelStudyFilesSuccess = createAction(
  '[Studies] Cancel Study Files Success',
  props<{ result: boolean }>()
);

export const CancelStudyFilesFailure = createAction(
  '[Studies] Cancel Study Files Failure',
  props<{ err: any }>()
);

export const CancelStudySubmissionSuccess = createAction(
  '[Studies] Cancel Study Submission for Sale/Horse Success',
  props<{ result: boolean }>()
);

export const CancelStudySubmissionFailure = createAction(
  '[Studies] Cancel Study Submission for Sale/Horse Failure',
  props<{ err: any }>()
);

export const SetStudyActiveStatusFilesSuccess = createAction(
  '[Studies] Archive Study Files Success',
  props<{ result: boolean }>()
);

export const SetStudyActiveStatusFilesFailure = createAction(
  '[Studies] Archive Study Files Failure',
  props<{ err: any }>()
);

export const CreateStudyFilesSuccess = createAction(
  '[Studies] Create Study Files Success',
  props<{ studyFile: StudyFile[] }>()
);

export const CreateStudyFilesFailure = createAction(
  '[Studies] Create Study Files Failure',
  props<{ err: any }>()
);

export const DeleteStudyFile = createAction(
  '[Studies] Delete Study File',
  props<{ studyFileId: number }>()
);

export const DeleteStudyFileSuccess = createAction(
  '[Studies] Delete Study File Success',
  props<{ studyFileId: number }>()
);

export const DeleteStudyFileFailure = createAction(
  '[Studies] Delete Study File Failure',
  props<{ err: any }>()
);

export const UpdateStudyFile = createAction(
  '[Studies] Update Study File',
  props<{
    studyFileId: number,
    mediaCategoryId: number,
    replacing: boolean,
    extra: boolean,
    isAdditional: boolean,
    studyId?: number,
    saleId?: number,
    horseId?: number
  }>()
);

export const UpdateStudyFileSuccess = createAction(
  '[Studies] Update Study File Success',
  props<{ studyFile: any }>()
);

export const UpdateStudyFileFailure = createAction(
  '[Studies] Update Study File Failure',
  props<{ err: any }>()
);

export const UpdateStudyFileStatuses = createAction(
  '[Studies] Update Study File Statuses',
  props<{
    studyFileIds: number[];
    statusId: number;
    reason: string;
    notificationData: any;
    acknowledgementData: StudyDraftSubmissionAcknowledgementsRequestDto;
  }>()
);

export const UpdateStudyFileStatusesSuccess = createAction(
  '[Studies] Update Study File Statuses Success',
  props<{ updateStatusResponse: UpdateStatusFileResponse }>()
);

export const UpdateStudyFileStatusesFailure = createAction(
  '[Studies] Update Study File Statuses Failure',
  props<{ err: any }>()
);

export const UpdateStudyFileStatusesAutoApprove = createAction(
  '[Studies] Update Study File Statuses Auto Approve',
  props<{
    studyFileIds: number[];
    statusId: number;
    reason: string;
    notificationData: any;
    acknowledgementData: StudyDraftSubmissionAcknowledgementsRequestDto;
  }>()
);

export const UpdateStudyFileStatusesAutoApproveSuccess = createAction(
  '[Studies] Update Study File Statuses Auto Approve Success',
  props<{ updateStatusResponse: UpdateStatusFileResponse }>()
);

export const UpdateStudyFileStatusesAutoApproveFailure = createAction(
  '[Studies] Update Study File Statuses Auto Approve Failure',
  props<{ err: any }>()
);

export const UpdateStudyStatus = createAction(
  '[Studies] Update Study Status',
  props<{ studyId: number; statusId: number; studyFileIds: number[] }>()
);

export const UpdateStudyStatusSuccess = createAction(
  '[Studies] Update Study Status Success',
  props<{ updateStatusResponse: UpdateStudyAndStudyFileStatusResponse }>()
);

export const UpdateStudyStatusFailure = createAction(
  '[Studies] Update Study Status Failure',
  props<{ err: any }>()
);

export const ClearStudyStatusResponseState = createAction(
  '[Studies] Clear Study Status Response State'
);

export const ClearStudyStatusState = createAction(
  '[Studies] Clear Study Status State'
);

export const GetSaleHorseStudies = createAction(
  '[Studies] Get Sale Horse Studies',
  props<{ saleId: number; horseId: number, isHideSpinner: boolean }>()
);

export const GetSaleHorseStudiesSuccess = createAction(
  '[Studies] Get Sale Horse Studies Success',
  props<{ saleHorseStudy: SaleHorseStudyBase }>()
);

export const GetSaleHorseStudiesFailure = createAction(
  '[Studies] Get Sale Horse Studies Failure',
  props<{ err: any }>()
);

export const StartActivity = createAction(
  '[Studies] Start Activity Studies',
  props<{ activity: ActivityLogModel }>()
);

export const StartActivitySuccess = createAction(
  '[Studies] Start Activity Studies Success',
  props<{ activityLogId: number }>()
);

export const StartActivityFailure = createAction(
  '[Studies] Start Activity Studies Failure',
  props<{ err: any }>()
);

export const EndActivity = createAction(
  '[Studies] End Activity Studies',
  props<{ activityLogId: number }>()
);

export const EndActivitySuccess = createAction(
  '[Studies] End Activity Studies Success',
  props<{ response: ActivityLogResponseModel }>()
);

export const EndActivityFailure = createAction(
  '[Studies] End Activity Studies Failure',
  props<{ err: any }>()
);

export const StudiesSearch = createAction(
  '[Studies] Studies Search',
  props<{ lotNumber: string }>()
);

export const StudiesSearchSuccess = createAction(
  '[Studies] Studies Search Success',
  props<{ response: LookupModel[] }>()
);

export const StudiesSearchFailure = createAction(
  '[Studies] Studies Search Failure',
  props<{ err: any }>()
);

export const GetStudyFilesBySaleHorse = createAction(
  '[Studies] Get Study Files By Sale Horse',
  props<{ saleHorse: SaleHorse }>()
);

export const GetStudyFilesBySaleHorseSuccess = createAction(
  '[Studies] Get Study Files By Sale Horse Success',
  props<{ saleHorse: SaleHorse; studyFiles: StudyFile[], isSalesCompany: boolean }>()
);

export const GetStudyFilesBySaleHorseFailure = createAction(
  '[Studies] Get Study Files By Sale Horse Failure',
  props<{ err: any }>()
);

export const GetStudyFilesWithSaleHorse = createAction(
  '[Studies] Get Study Files With Sale Horse',
  props<{ saleId: number; horseId: number }>()
);

export const GetStudyFilesWithSaleHorseSuccess = createAction(
  '[Studies] Get Study Files With Sale Horse Success',
  props<{ saleHorse: SaleHorse; studyFiles: StudyFile[], isSalesCompany: boolean }>()
);

export const GetStudyFilesWithSaleHorseFailure = createAction(
  '[Studies] Get Study Files With Sale Horse Failure',
  props<{ err: any }>()
);

export const StudiesSearchFilter = createAction(
  '[Studies] Studies Search Filter',
  props<{ query: string }>()
);

export const SetViewMode = createAction(
  '[Studies] Set View Mode',
  props<{ viewMode: ViewMode }>()
);

export const GetStudyFilesMimeTypes = createAction(
  '[Studies] Get Study Files Mime Types'
);

export const GetStudyFilesMimeTypesSuccess = createAction(
  '[Studies] Get Study Files Mime Types Success',
  props<{ mimeTypes: LookupModel[] }>()
);

export const GetStudyFilesMimeTypesFailure = createAction(
  '[Studies] Get Study Files Mime Types Failure',
  props<{ err: any }>()
);

export const UpdateStudyDescription = createAction(
  '[Studies] Update Study Description',
  props<{ studyId: number; description: string }>()
);

export const UpdateStudyFileDocType = createAction(
  '[Studies] Update Study File Doc Type',
  props<{
    studyFileId: number;
    docTypeId: number;
    docTypeName: string;
    isReport: boolean;
  }>()
);

export const GetStudyFilesDocTypes = createAction(
  '[Studies] Get Study Files Doc Types',
  props<{ isReport: boolean }>()
);

export const GetStudyFilesDocTypesSuccess = createAction(
  '[Studies] Get Study Files Doc Types Success',
  props<{ docTypes: LookupModel[] }>()
);

export const GetStudyFilesDocTypesFailure = createAction(
  '[Studies] Get Study Files Doc Types Failure',
  props<{ err: any }>()
);
export const UpdateDescriptionSuccess = createAction(
  '[Studies] Update Description Success',
  props<{ response: boolean }>()
);
export const UpdateDocTypeSuccess = createAction(
  '[Studies] Update Study Files Doc Types Success',
  props<{ studyFileId: number; docTypeId: number; docTypeName: string }>()
);

export const UpdateFailure = createAction(
  '[Studies] Get Study Files Doc Types Failure',
  props<{ err: any }>()
);

export const StudySubmitToSale = createAction(
  '[Studies] Study Submit To Sale',
  props<{ studySale: StudySaleSubmission }>()
);
export const StudySubmitToSaleSuccess = createAction(
  '[Studies] Study Submit To Sale Success',
  props<{ response: boolean }>()
);
export const StudySubmitToSaleFailure = createAction(
  '[Studies] Study Submit To Sale Failure',
  props<{ err: any }>()
);

export const UpdateSelectedTab = createAction(
  '[Studies] Update Selected Tab',
  props<{ submissionStatusId: number }>()
);
export const UpdateSelectedTabSuccess = createAction(
  '[Studies] Update Selected Tab Success',
  props<{ submissionStatusId: number }>()
);

export const GetSaleSettings = createAction(
  '[Studies] Get Sale Settings',
  props<{ saleId: number; horseId: number }>()
);
export const GetSaleSettingsSuccess = createAction(
  '[Studies] Get Sale Settings Success',
  props<{ saleSettings: SaleHorseSetting }>()
);
export const GetSaleSettingsFailure = createAction(
  '[Studies] Get Sale Settings Failure',
  props<{ err: any }>()
);

export const mergeStudies = createAction(
  '[Study] Merge Studies',
  props<{ studyId: number; studyIds: number[] }>()
);

export const mergeStudiesSuccess = createAction(
  '[Study] Merge Studies Success',
  props<{ success: boolean }>()
);

export const mergeStudiesFailure = createAction(
  '[Study] Merge Studies Failure',
  props<{ error: any }>()
);

export const clearMergeSuccess = createAction('[Study] Clear Merge Success');
export const clearStudiesLoaded = createAction('[Study] Clear Studies Loaded');
export const clearStudySubmitToSale = createAction(
  '[Study] Clear Studies Loaded'
);
export const clearCancelStudyAndDeleteFilesError = createAction(
  '[Study] Cancel Study And Delete Files Error'
);
export const clearDeleteFileError = createAction('[Study] Delete File Error');
export const clearSharedStudyState = createAction('[Study] Shared Study State');

export const ShareClinicalData = createAction(
  '[Study] Share Clinical Data',
  props<{ shareStudy: any }>()
);

export const ShareClinicalDataSuccess = createAction(
  '[Study] Share Clinical Data Success',
  props<{ success: boolean }>()
);

export const ShareClinicalDataFailure = createAction(
  '[Study] Share Clinical Data Failure',
  props<{ error: any }>()
);

export const GetSharedClinicalData = createAction(
  '[Study] Get Share Clinical Data',
  props<{ protected: string }>()
);

export const GetSharedClinicalDataSuccess = createAction(
  '[Study] Get Share Clinical Data Success',
  props<{ studyShare: StudyShareFileGet }>()
);

export const GetSharedClinicalDataFailure = createAction(
  '[Study] Get Share Clinical Data Failure',
  props<{ error: any }>()
);

export const OnCompleteBatch = createAction(
  '[Study] On Complete Batch',
  props<{ data: any }>()
);

export const OnCompleteBatchSuccess = createAction(
  '[Study] On Complete Batch Success',
  props<{ response: boolean }>()
);

export const OnCompleteBatchFailure = createAction(
  '[Study] On Complete Batch Failure',
  props<{ error: any }>()
);
export const ResetActivityState = createAction(
  '[Study] Reset Activity State'
);

export const ClearCancelStudyAndDeleteFilesSuccess = createAction(
  '[Study] Clear Cancel Study And Delete Files Success'
);
